// Agent.js (similar to Unit.js - listing component)
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import PageTitle from "../../components/PageTitle";
import { ActionButton, Buttons } from "../../components/Buttons";
import { TextInputForm } from "../../components/Forms";
import { FaMagnifyingGlass } from "react-icons/fa6";
import TableUI from "../../components/TableUI";
import CustomModal from "../../components/Modal";
import { MdOutlineDelete } from "react-icons/md";
import { TbCircleLetterI } from "react-icons/tb";
import { HiOutlineDotsVertical } from "react-icons/hi";
import AgentCreations from "../creations/AgentCreation";
import {
  fetchAgent,
  createAgent,
  updateAgent,
  deleteAgent,
} from "../../slices/agentSlice";
import NotifyData from "../../components/NotifyData";
import Pagnation from "../../components/Pagnation";
const Agent = () => {
  const dispatch = useDispatch();
  const { agent } = useSelector((state) => state.agent);
  const [formData, setFormData] = useState({});
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  // 🔹 Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  useEffect(() => {
    dispatch(fetchAgent());
  }, [dispatch]);
  // 🔹 Open / Close Modal
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  // 🔹 Edit / Create
  const handleEdit = (agent) => {
    setEditMode(true);
    setSelectedAgent(agent);
    setFormData({ agent_name: agent.agent_name });
    handleOpen();
  };
  const handleCreate = () => {
    setEditMode(false);
    setFormData({});
    handleOpen();
  };
  // 🔹 Submit Create / Update
  const handleSubmit = async () => {
    try {
      if (editMode) {
        await dispatch(
          updateAgent({ id: selectedAgent.id, agent_name: formData.agent_name })
        ).unwrap();
        NotifyData("Agent Updated Successfully", "success");
      } else {
        await dispatch(createAgent(formData)).unwrap();
        NotifyData("Agent Created Successfully", "success");
      }
    } catch (error) {
      NotifyData(
        editMode ? "Agent Update Failed" : "Agent Creation Failed",
        "error"
      );
    }
    handleClose();
    setFormData({});
    setEditMode(false);
  };
  // 🔹 Delete
  const handleDelete = async (id) => {
    try {
      await dispatch(deleteAgent(id)).unwrap();
      NotifyData("Agent Deleted Successfully", "success");
    } catch {
      NotifyData("Agent Deletion Failed", "error");
    }
  };
  // 🔹 Search Filter
  const filteredAgents =
    agent?.filter((item) =>
      item?.agent_name?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];
  // 🔹 Pagination Logic
  const total = filteredAgents.length;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = filteredAgents.slice(startIndex, endIndex);
  // 🔹 Table Headers & Data
  const RoleHead = ["No", "Agent Name"];
  const RoleData =
    currentData?.length > 0
      ? currentData.map((item, index) => ({
          values: [
            startIndex + index + 1,
            item.agent_name,
            <ActionButton
              options={[
                {
                  label: "Edit",
                  icon: <TbCircleLetterI />,
                  onClick: () => handleEdit(item),
                },
                {
                  label: "Delete",
                  icon: <MdOutlineDelete />,
                  onClick: () => handleDelete(item.id),
                },
              ]}
              label={<HiOutlineDotsVertical />}
            />,
          ],
        }))
      : [];
  return (
    <div id="main">
      <Container fluid>
        <Row>
          {/* Page Title */}
          <Col lg="6" className="py-3">
            <PageTitle PageTitle="Agent" showButton={false} />
          </Col>
          {/* Create Button */}
          <Col lg="6" className="py-3 text-end">
            <Buttons
              label="Create New"
              classname="crud-btn"
              OnClick={handleCreate}
            />
          </Col>
          {/* Search Input */}
          <Col lg="3" className="align-self-center">
            <TextInputForm
              prefix_icon={<FaMagnifyingGlass />}
              PlaceHolder="Search Agent Name"
              className="form-control-padleft"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // reset page when search changes
              }}
            />
          </Col>
          {/* Table */}
          <Col lg="12" xs="12">
            <TableUI headers={RoleHead} body={RoleData} className="table-end" />
          </Col>
          {/* Pagination */}
          <Col lg="12" xs="12" className="d-flex justify-content-end py-3">
            <Pagnation
              total={total}
              currentPage={currentPage}
              pageSize={pageSize}
              onPageChange={(page) => setCurrentPage(page)}
              onPageSizeChange={(current, size) => {
                setPageSize(size);
                setCurrentPage(1);
              }}
            />
          </Col>
        </Row>
      </Container>
      {/* Modal */}
      <CustomModal
        show={show}
        setShow={setShow}
        pageTitle={editMode ? <>Edit Agent</> : <>Create Agent</>}
        showButton={true}
        submitButton={true}
        label={editMode ? <>Update</> : <>Submit</>}
        CancelLabel={<>Cancel</>}
        BodyComponent={
          <AgentCreations formData={formData} setFormData={setFormData} />
        }
        OnClick={handleSubmit}
        Size="md"
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
    </div>
  );
};
export default Agent;
